// Central catalog of all static UI strings across the public site.
// Each entry: key -> English source. Wrap components with t('key', UI[k]).
// The admin "Translate EN → 15 languages" button will send this entire catalog
// to the backend which auto-translates it into every non-English language.

export const UI = {
  // ----- Nav / global -----
  'nav.home': 'Home',
  'nav.home_insurance': 'Home Insurance',
  'nav.health_insurance': 'Health Insurance',
  'nav.about': 'About',
  'nav.faq': 'FAQ',
  'nav.blog': 'Blog',
  'nav.contact': 'Contact',
  'nav.login': 'Login',
  'nav.logout': 'Logout',
  'nav.dashboard': 'Dashboard',
  'nav.language': 'Language',

  // ----- Hero / CTA (generic) -----
  'cta.get_quote': 'Get your quote',
  'cta.how_it_works': 'How it Works',
  'cta.start_quote': 'Start your quote',
  'cta.view_all_questions': 'View all questions',
  'cta.compare_again': 'Compare again',
  'cta.get_in_touch': 'Get in Touch',

  // ----- Homepage -----
  'home.policy_card_title': 'Policy Comparison',
  'home.policy_card_sub': '5 insurers · 60 sec quote',
  'home.faq_hero_text': 'Everything foreign property owners ask about Spanish home and health insurance.',
  'home.cta_title': 'Ready to save on your Spanish insurance?',
  'home.cta_sub': 'Get your live quote in under 10 minutes. No obligation.',

  // ----- Homepage hero features (fallback list) -----
  'features.holiday_homes': 'Holiday Homes',
  'features.permanent_homes': 'Permanent Homes',
  'features.rental_properties': 'Rental Properties',
  'features.apartments': 'Apartments',
  'features.villas': 'Villas',

  // ----- Insurance products cards -----
  'product.home.title': 'Home Insurance',
  'product.home.description': 'Comprehensive cover for your Spanish property. Compare quotes from trusted insurers in minutes.',
  'product.home.cta': 'Compare Home Insurance',
  'product.health.title': 'Health Insurance',
  'product.health.description': 'Private health cover for expats and non-residents. Fast, English-speaking service across Spain.',
  'product.health.cta': 'Compare Health Insurance',
  'product.community.title': 'Community Insurance',
  'product.community.description': 'Coverage for communities of owners (Comunidad de Propietarios). Launching soon.',
  'product.community.cta': 'Coming Soon',

  // ----- Why choose us -----
  'why.english_title': 'English speaking',
  'why.english_text': 'Full support in English across every step.',
  'why.swedish_title': 'Swedish speaking',
  'why.swedish_text': 'Personlig service på svenska.',
  'why.german_title': 'German speaking',
  'why.german_text': 'Beratung auf Deutsch verfügbar.',
  'why.spanish_title': 'Spanish speaking',
  'why.spanish_text': 'Atención en español nativo.',
  'why.trusted_title': 'Trusted insurers',
  'why.trusted_text': 'Policies from A-rated Spanish and international insurers.',
  'why.compare_title': 'Compare existing insurance',
  'why.compare_text': 'Upload your current policy and see if you can save.',
  'why.specialists_title': 'Non-resident specialists',
  'why.specialists_text': 'Dedicated to foreign property owners in Spain.',
  'why.fast_title': 'Fast online application',
  'why.fast_text': 'Complete the whole process in under 10 minutes.',

  // ----- How it works -----
  'how.step1_title': 'Fill in your property',
  'how.step1_text':  'Address, size, features and how you use it.',
  'how.step2_title': 'Answer a few questions',
  'how.step2_text':  'Construction, security, contents and claims.',
  'how.step3_title': 'Receive your quote',
  'how.step3_text':  'Live comparison of premiums from top insurers.',
  'how.step4_title': 'Accept online',
  'how.step4_text':  'Sign digitally and receive your policy by email.',

  // ----- About page -----
  'about.eyebrow': 'About us',
  'about.title': 'About EasySpanishInsurance',
  'about.subtitle': 'EasySpanishInsurance.com is a service from the real estate company Enova Estates S.L. Enova Estates operates a full-service property sales company in La Duquesa, Manilva, Casares, Sotogrande and Estepona on the Costa del Sol in Spain.',
  'about.enova_caption': 'Enova Estates · La Duquesa, Manilva',
  'about.enova_p1': 'EasySpanishInsurance is a do-it-yourself online platform that helps non-resident property owners in Spain compare and buy home, health and community insurance quickly, affordably, and without needing to call five agents.',
  'about.enova_p2': 'We built EasySpanishInsurance because we believe protecting your Spanish home should be simple. Every step is explained in plain language, your data is securely stored, and your policy schedule is saved for next renewal.',
  'about.enova_p3': 'Whether you own a holiday home, a rental property, or a primary investment in Spain, we make the entire process painless \u2014 from the first question to the final policy in your inbox.',
  'about.feature_designed': 'Designed for Non-Residents',
  'about.feature_save': 'Save Time Every Renewal',
  'about.feature_clear': 'Clear, Step-by-Step Process',
  'about.feature_pay': 'Pay Online, Receive Confirmation',
  'about.team_eyebrow': 'Our Team',
  'about.team_title': 'Meet the Experts Behind EasySpanishInsurance.com',
  'about.team_subtitle': 'Each member brings a wealth of experience and expertise, contributing to the innovative and customer-focused solutions we offer.',
  'about.role.bjorn': 'Co-owner and Head of Marketing',
  'about.role.tanja': 'CEO',
  'about.role.amor': 'Secretary',
  'about.role.sofia': 'CFO',
  'about.value_independent_title': 'Independent',
  'about.value_independent_text': 'We work for you, not the insurer. We compare policies from multiple providers to find your best fit.',
  'about.value_expats_title': 'Built for expats',
  'about.value_expats_text': 'Founded by non-residents for non-residents \u2014 we understand the specific needs of foreign owners in Spain.',
  'about.value_multi_title': 'Multilingual',
  'about.value_multi_text': 'Support in English, Swedish, German and Spanish across every step of the journey.',
  'about.value_transp_title': 'Transparent',
  'about.value_transp_text': 'Clear pricing, no hidden fees, and a real human at the other end of the phone when you need us.',

  // ----- FAQ page -----
  'faq.eyebrow': 'Help centre',
  'faq.title': 'Frequently asked questions',
  'faq.subtitle': 'Answers to the questions we hear most from foreign owners in Spain.',
  'faq.search_placeholder': 'Search questions…',
  'faq.empty': 'No questions match your search.',

  // FAQ items
  'faqitem.1.q': 'Do I need home insurance in Spain as a non-resident?',
  'faqitem.1.a': 'It is not legally required unless you have a mortgage, but strongly recommended. Non-resident properties are often left empty for long periods, making them vulnerable to water damage, break-ins and storms.',
  'faqitem.2.q': 'What does Spanish home insurance typically cover?',
  'faqitem.2.a': 'Standard policies cover building (Continente), contents (Contenido), third-party liability (Responsabilidad Civil), water damage, theft and legal defence. Add-ons include glass breakage, garden furniture and rental protection.',
  'faqitem.3.q': 'Can I keep my existing insurance and just compare?',
  'faqitem.3.a': 'Yes. Upload your current policy schedule and we will compare it against several alternatives so you can decide with the numbers in front of you.',
  'faqitem.4.q': 'How long does a quote take?',
  'faqitem.4.a': 'Under 10 minutes for most standard properties. Complex villas with high sums insured may take a little longer.',
  'faqitem.5.q': 'Which insurers do you compare?',
  'faqitem.5.a': 'We compare policies from leading Spanish and international insurers including Mapfre, Allianz, Liberty, Zurich, AXA and Caser.',
  'faqitem.6.q': 'Can I pay monthly?',
  'faqitem.6.a': 'Most of our partner insurers offer annual, semi-annual or monthly direct debit payments with no surcharge.',
  'faqitem.7.q': 'What if I have had claims in the past?',
  'faqitem.7.a': 'Previous claims may affect your premium but rarely prevent cover. Be honest so your policy is valid when you need it.',
  'faqitem.8.q': 'How does health insurance work for non-residents?',
  'faqitem.8.a': 'Private health insurance gives you access to Spain\u2019s excellent private hospitals in English. It is required for many non-lucrative visas and NIE-based residencies.',

  // ----- Contact page -----
  'contact.eyebrow': 'Contact',
  'contact.title': 'Get in Touch',
  'contact.subtitle': 'Have questions about Spanish home or health insurance? Our team is here to help \u2014 we respond within one business day.',
  'contact.email_label': 'Email',
  'contact.phone_label': 'Phone',
  'contact.office_label': 'Office',
  'contact.hours_label': 'Office hours',
  'contact.hours_value': 'Mon\u2013Fri  09:30 \u2013 18:00 CET',
  'contact.vat_label': 'EU VAT no',
  'contact.open_maps': 'Open in Google Maps',
  'contact.form_title': 'Send us a message',
  'contact.form_name': 'Your Name',
  'contact.form_email': 'Your Email',
  'contact.form_subject': 'Subject',
  'contact.form_message': 'Message',
  'contact.form_send': 'Send Message',
  'contact.form_sending': 'Sending...',
  'contact.form_sent_title': 'Message sent',
  'contact.form_sent_body': 'We respond within one business day.',
  'contact.form_error': 'Could not send',
  'contact.map_title': 'Find us in Manilva',

  // ----- Insurance wizard (Home Insurance page) -----
  'wizard.page_title': 'Home Insurance',
  'wizard.page_subtitle': 'Answer a few questions and receive live quotes from top insurers.',
  'wizard.step_property': 'Property',
  'wizard.step_owner': 'Owner',
  'wizard.step_construction': 'Construction',
  'wizard.step_contents': 'Contents',
  'wizard.step_review': 'Review',
  'wizard.step_quote': 'Quote',
  'wizard.step_of': 'Step {current} of {total}',
  'wizard.continue': 'Continue',
  'wizard.back': 'Back',
  'wizard.see_quote': 'See my quote',
  'wizard.save_account': 'Save to account',
  'wizard.save_login': 'Save & login to keep',
  'wizard.saving': 'Saving...',
  'wizard.help_title': 'Need help?',
  'wizard.help_body': 'Our English-speaking team can guide you through any step. Just email hello@easyspanishinsurance.com.',
  'wizard.data_safe_title': 'Your data is safe',
  'wizard.data_safe_body': 'Information is only used to generate your quote. We never sell personal data.',
  'wizard.saved_title': 'Saved for next year',
  'wizard.saved_body': 'Create an account and your property details will be pre-filled at renewal time.',
  'wizard.tax_found_title': 'We found your account on EasySpanishTax',
  'wizard.tax_found_body': 'Prefill the owner and property fields from your latest tax profile.',
  'wizard.prefill_btn': 'Prefill from EasySpanishTax',
  'wizard.prefilling': 'Filling...',
  'wizard.prefilled': 'Owner & property details filled in from EasySpanishTax. Please review and continue.',

  // Wizard section headings
  'wizard.property_title': 'Property details',
  'wizard.owner_title': 'Owner details',
  'wizard.current_insurance_title': 'Current insurance',
  'wizard.current_insurance_help': 'Optional — skip if you don\u2019t currently have a policy.',
  'wizard.construction_title': 'Construction',
  'wizard.security_title': 'Security',
  'wizard.security_help': 'Security features can reduce your premium significantly.',
  'wizard.contents_title': 'Contents',
  'wizard.contents_help': 'Give approximate values for anything you would want replaced.',
  'wizard.claims_title': 'Claims history',
  'wizard.claims_toggle': 'Any claims in the last 5 years?',
  'wizard.review_title': 'Review your details',
  'wizard.review_sub': 'Please confirm everything below before we generate your quotes.',
  'wizard.quotes_title': 'Your live quotes',
  'wizard.quotes_sub': 'Based on the information provided. Prices include IPS tax and broker fee.',

  // Wizard field labels
  'wf.address': 'Property address',
  'wf.province': 'Province',
  'wf.province_ph': 'Select province',
  'wf.municipality': 'Municipality',
  'wf.urbanisation': 'Urbanisation',
  'wf.year_built': 'Year built',
  'wf.built_m2': 'Built m\u00b2',
  'wf.bedrooms': 'Bedrooms',
  'wf.bathrooms': 'Bathrooms',
  'wf.features': 'Property features',
  'wf.pool': 'Swimming pool',
  'wf.garage': 'Garage',
  'wf.storage': 'Storage',
  'wf.garden': 'Garden',
  'wf.usage': 'Usage',
  'wf.rental': 'Rental property',
  'wf.holiday': 'Holiday home',
  'wf.permanent': 'Permanent residence',
  'wf.vacant': 'Vacant',
  'wf.full_name': 'Full name',
  'wf.email': 'Email',
  'wf.password': 'Password',
  'wf.password_ph': 'Choose a password (min 6 chars)',
  'wf.password_help': 'We\u2019ll create your account with this password so you can save quotes and get renewal reminders.',
  'wf.password_existing_ph': 'You already have an account, log in later to save',
  'wf.password_logged_in': 'You are already logged in',
  'wf.password_required': 'Please choose a password to create your account.',
  'wf.password_min': 'Password must be at least 6 characters.',
  'wf.password_wrong_sso': 'This email is registered on EasySpanishTax. Please log in from the top-right menu to link your account.',
  'wf.email_checking': 'Checking\u2026',
  'wf.email_existing': 'You already have an account. Log in from the top-right after your quote to save it.',
  'wf.phone': 'Phone',
  'wf.nie': 'NIE / Passport',
  'wf.country': 'Country of residence',
  'wf.insurer': 'Insurance company',
  'wf.insurer_ph': 'Select insurer',
  'wf.premium': 'Current premium (\u20ac / year)',
  'wf.renewal_date': 'Renewal date',
  'wf.cover_amount': 'Cover amount (\u20ac)',
  'wf.excess': 'Excess (\u20ac)',
  'wf.reason_change': 'Reason for changing',
  'wf.reason_ph': 'Select reason',
  'wf.reason_cheaper': 'Cheaper',
  'wf.reason_better': 'Better cover',
  'wf.reason_bad': 'Bad service',
  'wf.prop_type': 'Property type',
  'wf.prop_type_ph': 'Select type',
  'wf.material': 'Construction material',
  'wf.material_ph': 'Select material',
  'wf.roof': 'Roof type',
  'wf.roof_ph': 'Select roof',
  'wf.solar': 'Solar panels',
  'wf.sec_door': 'Security door',
  'wf.alarm': 'Alarm system',
  'wf.sec_company': 'Monitored by security company',
  'wf.safe': 'Safe',
  'wf.bars': 'Bars on windows',
  'wf.furniture': 'Furniture value (\u20ac)',
  'wf.jewellery': 'Jewellery (\u20ac)',
  'wf.computers': 'Computers (\u20ac)',
  'wf.electronics': 'Electronics (\u20ac)',
  'wf.art': 'Art (\u20ac)',
  'wf.sports': 'Sports equipment (\u20ac)',
  'wf.special': 'Special items',
  'wf.claim_count': 'How many?',
  'wf.claim_desc': 'Description',

  // Wizard quote card
  'wizard.best_price': 'Best price',
  'wizard.accept_quote': 'Accept quote',
  'wizard.per_year': '/year',
  'wizard.per_month': '/month',

  // ----- Health Insurance wizard -----
  'hw.page_title': 'Health Insurance',
  'hw.page_subtitle': 'Compare private Spanish health insurance in minutes — English-speaking doctors, private hospitals.',
  'hw.step_applicants': 'Applicants',
  'hw.step_contact': 'Contact',
  'hw.step_health': 'Health',
  'hw.step_cover': 'Cover',
  'hw.step_review': 'Review',
  'hw.step_quote': 'Quote',

  // Applicants step
  'hw.applicants_title': 'Who is being insured?',
  'hw.applicants_help': 'Add every person who should be covered under this policy.',
  'hw.add_applicant': 'Add another person',
  'hw.remove_applicant': 'Remove',
  'hw.applicant_relation': 'Relationship',
  'hw.rel_primary': 'Primary applicant',
  'hw.rel_spouse': 'Spouse / partner',
  'hw.rel_child': 'Child',
  'hw.rel_other': 'Other dependent',
  'hw.applicant_age': 'Age',
  'hw.applicant_name': 'Full name',
  'hw.applicant_gender': 'Gender',
  'hw.gender_ph': 'Select gender',
  'hw.gender_male': 'Male',
  'hw.gender_female': 'Female',
  'hw.gender_other': 'Other / prefer not to say',

  // Contact step
  'hw.contact_title': 'Your contact details',
  'hw.contact_help': 'We only use this to send your quotes. No spam.',
  'hw.field_name': 'Full name',
  'hw.field_email': 'Email',
  'hw.field_phone': 'Phone',
  'hw.field_nie': 'NIE / Passport',
  'hw.field_country': 'Country of residence',
  'hw.field_start': 'Preferred cover start date',
  'hw.field_current_insurer': 'Current insurer (optional)',
  'hw.current_insurer_ph': 'None / not sure',
  'hw.field_reason': 'Why are you comparing?',
  'hw.reason_first': 'First time buying private cover',
  'hw.reason_visa': 'Non-lucrative visa / residency',
  'hw.reason_switch': 'Switching from another insurer',
  'hw.reason_price': 'Looking for a better price',

  // Health step
  'hw.health_title': 'Health information',
  'hw.health_help': 'Insurers ask a short medical questionnaire. Be honest so your cover is valid when you need it.',
  'hw.smoker': 'Smoker or vaper',
  'hw.chronic': 'Any chronic conditions (diabetes, hypertension, asthma…)',
  'hw.medications': 'Currently on regular medication',
  'hw.pregnancy': 'Currently pregnant',
  'hw.surgery': 'Surgery planned in the next 12 months',
  'hw.hospital_last3': 'Hospitalised in the last 3 years',
  'hw.conditions_notes': 'Anything else we should know?',
  'hw.conditions_ph': 'e.g. mild asthma diagnosed 2019, controlled with inhaler',

  // Cover step
  'hw.cover_title': 'Cover preferences',
  'hw.cover_help': 'Choose the level you want and any extras. You can tweak this later on your quote.',
  'hw.cover_level': 'Cover level',
  'hw.level_basic': 'Basic — hospitals & GPs',
  'hw.level_standard': 'Standard — hospitals, GPs, specialists, basic dental',
  'hw.level_premium': 'Premium — top hospitals, full dental & optical',
  'hw.extras': 'Optional extras',
  'hw.no_copay': 'No copay on visits',
  'hw.dental': 'Full dental',
  'hw.maternity': 'Maternity',
  'hw.mental_health': 'Mental health',
  'hw.international': 'Worldwide emergency cover',
  'hw.private_room': 'Private room guaranteed',
  'hw.optical': 'Optical / glasses',
  'hw.chronic_extra': 'Chronic condition cover',

  // Review + quote
  'hw.review_title': 'Review your details',
  'hw.review_sub': 'Please confirm before we generate your quotes.',
  'hw.rev_applicants': 'Applicants',
  'hw.rev_contact': 'Contact',
  'hw.rev_health': 'Health',
  'hw.rev_cover': 'Cover',
  'hw.quotes_title': 'Your live health quotes',
  'hw.quotes_sub': 'Illustrative monthly premiums from top Spanish insurers, based on your answers.',

  // ----- Wizard filters & PDF -----
  'filters.title': 'Filter',
  'filters.clear': 'Clear filters',
  'filters.showing': 'Showing',
  'filters.of': 'of',
  'filters.insurers': 'insurers',
  'filters.none_match': 'No insurer matches all selected filters.',
  'filters.english_plus': 'English support: Excellent+',
  'filters.english_excellent': 'English support: Excellent only',
  'filters.am_best_a_plus': 'AM Best A+ only',
  'filters.am_best_a': 'AM Best A or better',
  'filters.dental': 'Includes dental',
  'filters.no_copay': 'No copay',
  'filters.international': 'Worldwide cover',
  'filters.water_damage': 'Water damage',
  'filters.legal_defence': 'Legal defence',

  'pdf.save_as_pdf': 'Save as PDF',
  'pdf.generating': 'Generating…',

  // ----- Insurer card -----
  'insurer.support_row_label': 'English support',
  'insurer.support_excellent': 'Excellent — native English support',
  'insurer.support_good': 'Good — English-speaking staff available',
  'insurer.support_limited': 'Limited — mostly Spanish, some English',
  'insurer.support_none': 'None — Spanish only',
  'insurer.support_unknown': 'Support level not yet verified',
  'insurer.read_review': 'Read full review',
  'insurer.hide_review': 'Hide details',
  'insurer.more_pros': 'More pros',
  'insurer.more_cons': 'More cons',
  'insurer.profile_soon': 'Full company profile coming soon.',

  // Quote results
  'quote.title': 'Your comparison',
  'quote.sub': 'Five insurers, live prices, all with English-speaking support.',
  'quote.cheapest': 'Cheapest',
  'quote.per_year': '/ year',
  'quote.select': 'Choose this policy',
  'quote.rating': 'Rating',
  'quote.highlights': 'Highlights',

  // ----- Blog -----
  'blog.eyebrow': 'Blog',
  'blog.title': 'Insurance insights for expats in Spain',
  'blog.subtitle': 'Guides, comparisons and news for foreign property owners.',
  'blog.search_placeholder': 'Search articles…',
  'blog.no_results_title': 'No articles match your search',
  'blog.no_results_sub': 'Try a different keyword or category.',
  'blog.clear_filters': 'Clear filters',
  'blog.loading': 'Loading…',
  'blog.read_article': 'Read article',
  'blog.back_to_blog': 'Back to blog',
  'blog.all_categories': 'All',

  // ----- Health Insurance page (short) -----
  'health.hero_eyebrow': 'Health Insurance for Expats',
  'health.hero_title': 'Private health cover across Spain',
  'health.hero_sub': 'English-speaking doctors, private hospitals, dental and family plans — compare in minutes.',

  // ----- Footer -----
  'footer.newsletter_title': 'Newsletter',
  'footer.newsletter_body': 'Insurance tips and expat news, straight to your inbox. No spam.',
  'footer.newsletter_name': 'Your name',
  'footer.newsletter_email': 'your@email.com',
  'footer.newsletter_button': 'Subscribe',
  'footer.newsletter_thanks': 'Thanks — check your inbox!',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.cookies': 'Cookies',
  'footer.section_insurance': 'Insurance',
  'footer.section_company': 'Company',
  'footer.section_contact': 'Contact',
  'footer.community_soon': 'Community Insurance (soon)',
};

export default UI;
